import React from "react";
import Button from "../../../components/button";
import InsightsAiIcon from "../../../images/ai-insights.svg";

const ToggleAIButton = ({ active, onClick, text = "Insights" }) => {
  return (
    <Button
      icon={InsightsAiIcon}
      text={text}
      onClick={onClick}
      active={active}
    />
  );
};

export default ToggleAIButton;
